import React, { useEffect } from "react";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import banner from "../asset/blogs-banner.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { blogImgUrl, ImgUrl } from "../../constant";
import { useAllBlogQuery } from "../../redux/API/BlogApi";
import BlogCard from "../components/card/BlogCard";
const Blog = () => {
  const { data: blogData } = useAllBlogQuery();
  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600,
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);

  return (
    <>
      <Navbar />
      <div className="hero_banner">
        <img src={banner} alt="" className="w-100 h-100" />
        <div className="banner_content position-absolute start-0 w-100 overflow-hidden pt-lg-5">
          <div className="container">
            <div className="row">
              <h1 className="text-white fw-bold banner-text" data-aos="fade-up">
                Blogs
              </h1>
              <h3
                className="fw-normal banner-text text-white"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                Unforgetable experience for ever explorer
              </h3>
            </div>
          </div>
        </div>
      </div>
      <section className="mt-3 container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <Link to="/" className="text-success">
                Home
              </Link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Blogs
            </li>
          </ol>
        </nav>
        <div className="container">
          <h2 className="fw-semibold" data-aos="fade-up">
            Tales of our Travellers : Blogs
          </h2>
          <div className="row mt-3 gy-3">
            {blogData?.data.allBlogs?.length > 0 ? (
              blogData.data.allBlogs.map((blog) => (
                <div
                  key={blog.slug}
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                >
                  <Link
                    to={`/blogs/${blog.slug}`}
                    className="text-decoration-none text-unset"
                  >
                    <BlogCard
                      title={blog.title}
                      desc={
                        blog.description
                          ? blog.description
                              .replace(/(<([^>]+)>)/gi, "")
                              .slice(0, 45) + "..."
                          : "Read more about this amazing journey"
                      }
                      img={`${ImgUrl}${blogImgUrl}${blog.image}`}
                      border={"#005028"}
                    />
                  
                  </Link>
                </div>
              ))
            ) : (
              <p>No Blogs Available</p>
            )}
          </div>
        </div>
        {/* </div> */}
      </section>
      <Footer />
    </>
  );
};

export default Blog;
